function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.5 47.8h29.9V144H2.5zM17.4 0a17.33 17.33 0 11-.14 0h.14M51.2 47.8h28.6V61h.4c4-7.6 13.8-15.5 28.2-15.5 30.3 0 35.9 19.9 35.9 45.8V144h-29.9V97.2c0-11.2-.2-25.5-15.5-25.5-15.6 0-18 12.2-18 24.7V144H51.2z"
});

var SvgSocialLinkedin = function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "c74c2107-853f-4940-bf5a-6185d0aca37e",
    viewBox: "0 0 144.3 144",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgSocialLinkedin;